import React from "react";

export default function Sustainability() {
  return (
    <div data-testid="sustainability-page">
      <section className="container-lookers py-20 max-w-2xl">
        <h1 className="font-serif text-5xl mb-3 text-zinc-900">
          Another Look. Another Life.
        </h1>
        <p className="text-sm text-zinc-500 mb-6 leading-relaxed">
          Quality eyewear is made to last. Changing prescriptions, styles and preferences cause thousands of usable frames to become unwanted. Lookers creates a market for those frames — helping keep designer eyewear in circulation by finding it a new owner instead of leaving it forgotten in a drawer or discarded unnecessarily.
        </p>
        <p className="text-sm text-zinc-500 leading-relaxed">
          Selling and buying preloved eyewear means getting more use from something that has already been made. It's a smarter way to look at fashion — better for your wallet, and a better use of something already made.
        </p>
      </section>
      <section className="bg-white py-16 border-y border-zinc-100">
        <div className="container-lookers">
          <h2 className="font-serif text-3xl mb-8 text-zinc-900">
            See Things Differently
          </h2>
          <p className="text-sm text-zinc-500 max-w-xl mb-10">Millions of perfectly wearable frames spend their lives sitting inside drawers. Lookers gives them another chance. We buy quality designer eyewear, inspect it, prepare it for its next owner and put it back into circulation.</p>
        </div>
      </section>
    </div>
  );
}
